<template>
<div class="card card-body p-2">
    <div class="form-group" v-if="actions.post">
        <div class="input-group input-group-alternative mb-1 mt-1">
            <input placeholder="Nombre del tipo" type="text" class="form-control" v-model="newItem.caption">
            <div class="input-group-append">
              <button
              
              type="button" class="btn btn-icon btn-3" 
              :class="editModeTipo ? 'btn-info':'btn-success'" 
               :disabled="invalidCaption || loading || ItemAlreadyExists"
              @click.prevent="setItem">
                <i class="fa" :class="editModeTipo ? 'fa-save':'fa-plus-circle'"></i>
              </button>
              <button v-if="editModeTipo" @click="closeEdit" class="btn btn-icon btn-3 btn-secondary" v-b-tooltip.hover title="Cerrar edición"><i class="fa fa-times"></i></button>
            </div>
        </div>
    </div>
    <div class="alert alert-danger text-small p-2 fadeIn" v-if="ItemAlreadyExists">
        Este registro ya existe
    </div>
    <ul class="list-group mt-0">
        <li 
        class="list-group-item d-flex justify-content-between align-items-center text-capitalize text-small p-2"
         v-for="(tipo, indexTipo) in filteredRows.slice(pageStart, pageStart + countOfPage)" :key="'keytipo_'+indexTipo"
         :class="{ 'active': newItem.id == tipo.id }">
        {{ tipo.caption }}
        <button v-if="actions.put" type="button" @click="toggleEdit(tipo)" class="btn btn-outline-info btn-xm"><i class="fa fa-edit "></i></button>
        </li>
        <!-- v-for="tipo in tipos" :key="'keytipo_'+tipo.id" -->
    </ul>

  <div class="card-footer">
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" v-bind:class="{'disabled': (currPage === 1)}" @click.prevent="setPage(currPage-1)"><a class="page-link" href=""><i class="fa fa-caret-left"></i></a></li>
        <li class="page-item" v-for="(n,indexPage) in totalPage" v-bind:class="{'active': (currPage === (n))}" @click.prevent="setPage(n)" :key="indexPage+'hola'+n"><a class="page-link" href="">{{n}}</a></li>
        <li class="page-item" v-bind:class="{'disabled': (currPage === totalPage)}" @click.prevent="setPage(currPage+1)"><a class="page-link" href=""><i class="fa fa-caret-right"></i></a></li>
      </ul>
    </nav>
  </div>
</div>
</template>
<script>
import _ from 'underscore'
import sysMsg from '@/helpers/system.message'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'tipos',
  props:['actions'],
  data() {
      return {
        loading: false,
        countOfPage: 6,
        currPage: 1,
        filter_name: '',
        newItem:  { id: 0, caption: '' }
      }
  },
  computed: {
    ...mapGetters('baneados', ['tipos']),
    filteredRows: function(){
      var filter_name = this.filter_name.toLowerCase();
      return ( this.filter_name.trim() !== '' ) ? this.tipos.filter(function(d){ return d.caption.toLowerCase().indexOf(filter_name) > -1; }) : this.tipos;
    },
    pageStart(){
        return (this.currPage - 1) * this.countOfPage;
      },
    totalPage(){
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    invalidCaption() {
      return this.newItem.caption.trim().length == 0
    },
    editModeTipo(){
      return this.newItem.id > 0;
    },
    ItemAlreadyExists(){
      return this.tipos.find(item => item.caption.toString().toLowerCase().trim() == this.newItem.caption.toString().toLowerCase().trim()) != undefined && this.newItem.id == 0
    }
  },
  methods: {
    ...mapActions('baneados', ['getTipos', 'setTipo',  'removeTipo']),
    setPage: function(idx){
      if( idx <= 0 || idx > this.totalPage ){
        return;
      }
      this.currPage = idx;
    },
    setItem() {
      this.setTipo(this.newItem).then(() => {
        this.newItem =  { id: 0, caption: '' }
      }).catch(error => {
        sysMsg.getResponseMessage(error.response);
      })
    },
    toggleEdit(item) {
      this.newItem = item
    },
    closeEdit() {
      this.newItem =  { id: 0, caption: '' }
    }
  }
}
</script>

